import { DEFAULT_BORDER_RADIUS } from 'theme/constants';
import { Components, Theme } from '@mui/material/styles';
import { palette } from 'theme/palette';
import { typography } from 'theme/typography';

export const MuiSelect: Components<Theme>['MuiSelect'] = {
  styleOverrides: {
    root: ({ ownerState }) => {
      let additionalStyle = {};
      if (ownerState.variant === 'filled') {
        additionalStyle = {
          backgroundColor: 'white',
          '&::before, &::after, &:hover:not(.Mui-disabled, .Mui-error):before': {
            borderBottom: 'none',
          },
          '& fieldset': {
            border: 0,
            borderColor: 'white',
          },
        };
      }

      return {
        borderRadius: DEFAULT_BORDER_RADIUS,
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: palette.text.tertiary,
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
          borderColor: palette.text.secondary,
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
          borderColor: palette.grey[600],
        },
        ...additionalStyle,
      };
    },
    iconFilled: ({ theme }) => ({
      right: 'unset',
      left: theme.spacing(7),
    }),
    filled: ({ theme }) => ({
      borderRadius: DEFAULT_BORDER_RADIUS,
      padding: `${theme.spacing(12, 16, 10, 36)} !important`,
      boxShadow: `0px 0px ${theme.spacing(5)} 0px #00000014, 0px ${theme.spacing(
        1,
      )} ${theme.spacing(2)} 0px #00000014`,
      color: palette.text.secondary,
      height: theme.spacing(40),
      boxSizing: 'border-box',
      ...typography.button,
    }),
    nativeInput: {
      ...typography.text1,
      color: palette.text.primary,
      '&::placeholder': {
        ...typography.text1,
        color: palette.text.secondary,
        opacity: 1,
      },
    },
    select: ({ theme }) => ({
      paddingTop: theme.spacing(11),
      paddingBottom: theme.spacing(11),
      paddingRight: `${theme.spacing(32)} !important`,
    }),
  },
};
